import API from '../../api'
import { getToken } from '../../utils'
import store from 'store2'

export default class PreviousSearchHandler {
  constructor() {
    if(PreviousSearchHandler.instance) {
      return PreviousSearchHandler.instance
    }

    PreviousSearchHandler.instance = this

    this.results = []
    this.promise = undefined

    return this
  }

  getResults() {
    if(!this.promise) {
      this.promise = new Promise(resolve => {
        if(this.results.length) {
          resolve(this.results)
        } else if(getToken()) {
          API('account/search-requests/', false, true).get().then(data => {
            if(data) {
              let formattedSearch = []
              data.forEach(function(item) {
                formattedSearch.push(item.searchData)
              })
              this.results = formattedSearch
              resolve(this.results)
            }
          })
        } else {
          this.results = store('previousSearch') || []
          resolve(this.results)
        }
      })
    }

    return this.promise
  }

  setResults(searchData) {
    if(!this.isValid(searchData)) {
      return false
    }
    if(getToken()) {
      API(`account/search-requests/`, false, true).post({
        searchData,
      })
    } else {
      let previousSearch = store('previousSearch') || []
      previousSearch.unshift({ ...searchData })
      store('previousSearch', previousSearch.splice(0, 4))
    }
  }

  isValid(item) {
    if(!item.title || !item.dateFrom || !item.dateTo || !item.roomParams || !item.departureMonth) {
      return false
    }
    let isUnique = true
    this.results.forEach(currentItem => {
      if(currentItem.title === item.title &&
        currentItem.dateFrom === item.dateFrom &&
        currentItem.dateTo === item.dateTo &&
        currentItem.departureMonth.id === item.departureMonth.id &&
        currentItem.modelType === item.modelType &&
        currentItem.roomParams.totalGuests === item.roomParams.totalGuests &&
        currentItem.roomParams.rooms === item.roomParams.rooms
      ) {
        console.log(isUnique)
        isUnique = false
      }
    })

    return isUnique
  }
}
